import DEFAULT_THEME from './default-theme';
const LARGE_THEME = DEFAULT_THEME.withParams({
    // headerVerticalPaddingScale: 1.3,
    rowVerticalPaddingScale: 1.3,
    // headerFontSize: "var(--text-sm)"
});
export default LARGE_THEME;
